// PL
export const hotelCalendarHc = {
  toolbar: {
    bulkEdit: "Edycja masowa",
    cfgTitle: "Ustawienia kalendarza",
    syncSection: "Synchronizacja",
    resyncOta: "Zsynchronizuj ponownie z OTA",
    resyncOtaSub: "Wyślij dostępność i ceny z powrotem do kanału.",
  },
  mode: {
    calendar: "Kalendarz",
    rates: "Ceny",
  },
  search: {
    placeholder: "Szukaj gościa lub kodu…",
    clear: "Wyczyść",
    go: "Szukaj",
    resultsHint: "Wyniki: {count} · wybierz jeden:",
    combo: "Łączone · {count} pokoi",
  },
  header: {
    occupancy: "Obłożenie {pct}%",
  },
  type: {
    roomsAbbr: "pokoi",
    configTitle: "Ustawienia typu pokoju (OTA oraz reguły przyjazdów i wyjazdów)",
    otaConnected: "OTA połączone",
    subscribeToConnect: "Wykup subskrypcję, aby połączyć OTA",
  },
  rtCell: {
    editTooltip: "Kliknij, aby edytować dostępność, cenę, minimalny pobyt i zamknięcie",
    overbookRisk: "Ryzyko overbookingu",
    closedTag: "Zamknięte",
  },
  rules: {
    sameDayCutoff: "Sprzedaż na ten sam dzień do {time}",
  },
  organizeRow: {
    title: "Do uporządkowania",
    unplacedCount: "{count} nieprzypisana rezerwacja | {count} nieprzypisane rezerwacje | {count} nieprzypisanych rezerwacji",
    autoTooltip: "Automatycznie przestawia rezerwacje między pokojami, aby wszystkie się zmieściły",
    organizing: "Porządkowanie…",
    organize: "Uporządkuj",
  },
  footer: {
    available: "Dostępny",
    unavailable: "Niedostępny",
    closed: "Zamknięty",
    overbookRisk: "Ryzyko overbookingu",
    realtime: "Wartości aktualizują się w czasie rzeczywistym",
    timezone: "Strefa czasowa: {tz}",
  },
  dayEdit: {
    oneDay: "jeden dzień",
    open: "Otwarty",
    closed: "Zamknięty",
    priceLabel: "Cena · taryfa standardowa",
    minStayLabel: "Minimalny pobyt (noce)",
    forSaleLabel: "Pokoje w sprzedaży",
    forSaleHint: "limit · maks. {max}",
    applyMultiple: "Zastosować do kilku dat?",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    save: "Zapisz",
  },
  roomMenu: {
    create: "Utwórz rezerwację",
    createSub: "Rezerwacja na wybrany zakres",
    block: "Zablokuj 1 pokój",
    blockSub: "Zamknij ten pokój na wybrany zakres",
    unblock: "Usuń blokadę",
    unblockSub: "Otwórz ponownie ten pokój na wybrany zakres",
    oos: "Wyłączony z użytku",
    oosSub: "Konserwacja tego pokoju",
  },
  closureMenu: {
    turnoverTitle: "Ustawione przez czas na przygotowanie",
    turnoverSub: "Przesuwa się wraz z datami rezerwacji i znika po jej anulowaniu.",
    changeRule: "Zmień regułę",
    changeRuleSub: "Dostosuj lub wyłącz czas na przygotowanie",
    editReason: "Edytuj powód",
    editReasonSub: "Zmień powód blokady",
    changeRoom: "Zmień pokój",
    changeRoomSub: "Przenieś do innego pokoju tego typu",
    unblock: "Usuń blokadę",
    unblockSub: "Otwórz ponownie i zwolnij miejsce",
    moveTo: "Przenieś do…",
    noOtherRooms: "Nie ma innych pokoi w tym typie.",
    barTooltip: "Blokada: {reason} · kliknij, aby edytować lub usunąć",
  },
  typeConfig: {
    seasons: "Price seasons",
    seasonsSub: "Raise or lower prices by date",
    manageOta: "Zarządzaj połączeniem OTA",
    connectOta: "Połącz OTA",
    otaSub: "Synchronizuj obiekt z OTA",
    arrivalRules: "Reguły przyjazdów i wyjazdów",
    arrivalRulesSub: "Dozwolone dni check-inu / check-outu",
  },
  // La habitación se ocupó unas HORAS, no una noche: en el calendario por
  // días se lee como un bloqueo con su motivo.
  hourly: {
    sold: "Sprzedana na godziny",
    soldOne: "Sprzedana na godziny · {range}",
    soldMany: "Sprzedana na godziny · {count} pobytów",
  },
  tooltip: {
    past: "Przeszłość",
    unassignedHtml: "<strong>Brak przypisanego pokoju.</strong> Dostępność jest rozłożona między pokoje. Użyj opcji <strong>Uporządkuj</strong>, aby przestawić ją automatycznie, albo kliknij i przypisz pokój.",
    nights: "{count} noc | {count} noce | {count} nocy",
    guests: "{count} gość | {count} goście | {count} gości",
  },
  channels: {
    direct: "Bezpośrednia",
  },
  syncModal: {
    title: "Synchronizacja z OTA",
    message: "Dostępność i maksymalny pobyt z tego kalendarza zostaną przeliczone i wysłane ponownie do OTA.",
    confirm: "Tak, synchronizuj",
    cancel: "Anuluj",
  },
  syncTooltip: {
    can: "Przelicza i ponownie wysyła dostępność oraz maksymalny pobyt do OTA (zapobiega overbookingowi).",
    cannot: "Połącz obiekt z kanałem, aby móc synchronizować.",
  },
  block: {
    editTitle: "Edytuj powód",
    createTitle: "Zablokuj pokój",
    reasonLabel: "Powód blokady",
    reasonHint: "(będzie widoczny w kalendarzu)",
    placeholder: "np. Konserwacja, użytek właściciela…",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    saveReason: "Zapisz powód",
    blockBtn: "Zablokuj",
    defaultReason: "Zablokowane",
    thisRoom: "ten pokój",
    editReasonMsg: `Edytuj powód blokady dla "{room}" ({count} noc). | Edytuj powód blokady dla "{room}" ({count} noce). | Edytuj powód blokady dla "{room}" ({count} nocy).`,
    createMsg: `Pokój "{room}" ({unit}) zostanie zamknięty na {count} noc. W tych terminach nie będzie można go rezerwować; pozostałe pokoje tego typu nadal będą dostępne. | Pokój "{room}" ({unit}) zostanie zamknięty na {count} noce. W tych terminach nie będzie można go rezerwować; pozostałe pokoje tego typu nadal będą dostępne. | Pokój "{room}" ({unit}) zostanie zamknięty na {count} nocy. W tych terminach nie będzie można go rezerwować; pozostałe pokoje tego typu nadal będą dostępne.`,
    presets: {
      maintenance: "Konserwacja",
      ownerUse: "Użytek właściciela",
      renovation: "Remont",
      deepCleaning: "Sprzątanie gruntowne",
      externalReserved: "Zarezerwowane (zewnętrznie)",
    },
  },
  organizeModal: {
    title: "Uporządkuj automatycznie",
    bodyHtml: `Znajdziemy najlepsze dopasowanie i <strong>przestawimy rezerwacje między pokojami</strong> tego typu tak, aby <strong>zmieściła się {count} nieprzypisana rezerwacja</strong> jedna po drugiej. | Znajdziemy najlepsze dopasowanie i <strong>przestawimy rezerwacje między pokojami</strong> tego typu tak, aby <strong>zmieściły się {count} nieprzypisane rezerwacje</strong> jedna po drugiej. | Znajdziemy najlepsze dopasowanie i <strong>przestawimy rezerwacje między pokojami</strong> tego typu tak, aby <strong>zmieściło się {count} nieprzypisanych rezerwacji</strong> jedna po drugiej.`,
    point1Html: "Zmienia się tylko przypisany <strong>fizyczny pokój</strong>.",
    point2Html: "<strong>Daty, ceny i goście</strong> pozostają bez zmian.",
    point3: "Jeśli któraś nie zmieści się jedna po drugiej, poinformujemy o tym.",
    cancel: "Anuluj",
    organizing: "Porządkowanie…",
    confirm: "Tak, uporządkuj",
  },
  empty: {
    noHotelTitle: "Brak ofert typu hotel",
    noHotelSubHtml: "Utwórz ofertę typu <strong>Hotel</strong> lub <strong>Kemping</strong>, aby zacząć zarządzać dostępnością według pokoi.",
    noHotelBtn: "Przejdź do ofert",
    noRoomsTitle: "Brak pokoi w ofercie: {name}",
    noRoomsSub: "Ta oferta nie ma jeszcze zarejestrowanych pokoi. Dodaj pokoje w ustawieniach oferty, aby zobaczyć kalendarz.",
    noRoomsBtn: "Skonfiguruj ofertę",
  },
  mock: {
    today: "Dziś",
    month: "MAJ 2026",
    searchPlaceholder: "Szukaj po nazwisku lub kodzie…",
    searchBtn: "Szukaj",
    createBtn: "Utwórz rezerwację",
    na: "N/d",
    forSaleLabel: "Dost. w sprzedaży",
    suiteDeluxe: "Apartament Deluxe",
    standardRoom: "Pokój standardowy",
    roomsCount2: "(2 pokoje)",
    roomsCount3: "(3 pokoje)",
    no: "Nr",
    room101: "Pokój 101",
    room102: "Pokój 102",
    room201: "Pokój 201",
    room202: "Pokój 202",
    room203: "Pokój 203",
    d1: "Pon 1",
    d2: "Wt 2",
    d3: "Śr 3",
    d4: "Czw 4",
    d5: "Pt 5",
    d6: "Sob 6",
    d7: "Nd 7",
    d8: "Pon 8",
    d9: "Wt 9",
    d10: "Śr 10",
    d11: "Czw 11",
    d12: "Pt 12",
  },
  ops: {
    closingDay: "Zamykanie dnia…",
    openingDay: "Otwieranie dnia…",
    saving: "Zapisywanie…",
    movingBlock: "Przenoszenie blokady…",
    swappingBlockReservation: "Zamiana blokady i rezerwacji…",
    swappingReservationBlock: "Zamiana rezerwacji i blokady…",
    swappingRooms: "Zamiana pokoi…",
    changingRoom: "Zmiana pokoju…",
    organizingRooms: "Porządkowanie pokoi…",
    syncingWithOta: "Synchronizowanie kalendarza z OTA…",
    processing: "Przetwarzanie…",
    settingMaintenance: "Ustawianie konserwacji…",
    clearingMaintenance: "Usuwanie konserwacji…",
    updatingAvailability: "Aktualizowanie dostępności…",
    updatingReason: "Aktualizowanie powodu…",
    closingRoom: "Zamykanie pokoju…",
    removingBlock: "Usuwanie blokady…",
  },
  toasts: {
    dayClosed: "Dzień zamknięty",
    dayOpened: "Dzień otwarty",
    availabilityUpdateErr: "Nie udało się zaktualizować dostępności",
    dayUpdated: "Dzień zaktualizowany",
    daySaveErr: "Nie udało się zapisać dnia",
    moveTargetMultipleReservations: "Cel ma kilka rezerwacji w tym zakresie; przenieś je ręcznie.",
    roomRejectsBlock: "Ten pokój nie przyjmuje blokady w tym zakresie",
    blockMoved: "Blokada przeniesiona do innego pokoju",
    blockMoveErr: "Nie udało się przenieść blokady",
    swapStartErr: "Nie udało się rozpocząć zamiany",
    reservationNoFitSwap: "Rezerwacja nie mieści się w drugim pokoju w całym swoim zakresie; nie udało się jej zamienić.",
    reservationMoveErr: "Nie udało się przenieść rezerwacji",
    swapCompleteErr: "Nie udało się dokończyć zamiany (została cofnięta)",
    blockReservationSwapped: "Blokada i rezerwacja zostały zamienione",
    swapErr: "Nie udało się dokończyć zamiany",
    rangeHasOccupiedOrClosed: "Zakres obejmuje zajęte lub zamknięte noce w tym pokoju.",
    organizeErr: "Nie udało się uporządkować automatycznie.",
    organizeNothing: "Nie było nic do uporządkowania.",
    organizePartial: "Uporządkowano rezerwacje: {done}, ale {unplaced} nie mieszczą się jedna po drugiej w żadnej kombinacji.",
    organizeDoneAssigned: "Kalendarz uporządkowany: przypisano {assigned}",
    organizeDoneMoved: ", przeniesiono do innego pokoju: {moved}",
    swapGroupDone: "Zamiana grupowa zakończona: {groupCount} ⇄ {swappedCount} rezerwacji.",
    roomsSwappedWith: "Pokoje zamienione z: {names}.",
    noPropertyToSync: "Nie ma obiektu do synchronizacji.",
    calendarResynced: "Kalendarz został przeliczony i zsynchronizowany z OTA.",
    syncErr: "Nie udało się zsynchronizować kalendarza z OTA.",
    genericError: "Błąd",
    reservationNoFitSwapStrict: "Nie udało się zamienić: rezerwacja nie jest wolna w całym swoim zakresie.",
    reservationBlockSwapped: "Rezerwacja i blokada zostały zamienione",
    roomCloseErr: "Nie udało się zamknąć pokoju",
    reasonUpdated: "Powód zaktualizowany",
    roomClosedInRange: "Pokój zamknięty na wybrany zakres",
    blockRemoved: "Blokada usunięta",
    blockRemoveErr: "Nie udało się usunąć blokady",
    searchMinChars: "Wpisz co najmniej 2 znaki, aby wyszukać",
    searchNoResults: "Nie znaleziono rezerwacji dla tego wyszukiwania",
    searchErr: "Błąd podczas wyszukiwania rezerwacji",
  },
  summary: {
    stateAvailable: "Dostępny",
    stateClosed: "Zamknięty",
    stateNoDisp: "N/d",
  },
};
